import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { SimpleFrontendChartStyle } from '@/interfaces/chartStyle';

export function getSampleChartStyleFromCache(recid: number): SimpleFrontendChartStyle | null {
  const savedChartsStore = useSavedChartsStore();

  for (const sampleChartStyleGroup of savedChartsStore.sampleChartStyleGroups) {
    for (const sampleChartStyle of sampleChartStyleGroup.charts) {
      if (sampleChartStyle.recid === recid) {
        return sampleChartStyle;
      }
    }
  }

  return null;
}
